export default __webpack_public_path__ + "static/media/v_wdt_c_0.6d5664f7.mp3";